export default __webpack_public_path__ + "static/media/RedCircles.0659d23b.svg";